import Cookie from 'js-cookie';
import { API_URL, JWT_TOKEN_KEY } from './constants';

const originalConsoleError = console.error;

/**
 * Trigger our own error reporting on console error
 */
export default function register() {
	console.error = function(message, error) {
		const url = window.location.href;
		const environment = window.navigator.appVersion;
		const token = Cookie.get(JWT_TOKEN_KEY) || null;

		const errorData = errorToJSON(message);

		// Ignore mixpanel error because of user id 2148, no names
		if (errorData.indexOf('Mixpanel error') !== -1) return;

		sendError(errorData, url, environment, token);

		originalConsoleError.apply(this, arguments);
	};
}

/**
 * Send error to server
 *
 * @param string error
 * @param string url
 * @param string environment
 * @param string token
 */
function sendError(error, url, environment, token = null) {
	fetch(API_URL + 'client-errors', {
		method: 'post',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			error,
			url,
			environment,
			token,
		}),
	});
}

/**
 * Make json string from error
 * @param Error message
 */
function errorToJSON(error) {
	return JSON.stringify(error, Object.getOwnPropertyNames(error));
}



// WEBPACK FOOTER //
// ./src/registerErrorReporter.js